import {Project} from '@package/shared'
import type {z} from 'zod'

export const FormValues = Project.pick({
  name: true,
  color: true,
  workdays: true,
})
export type FormValues = z.infer<typeof FormValues>
